import { render, staticRenderFns } from "./EFS.vue?vue&type=template&id=2d7f4c94"
import script from "./EFS.vue?vue&type=script&lang=js"
export * from "./EFS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports